import { render, staticRenderFns } from "./cUserFeedback.vue?vue&type=template&id=addf2df8&scoped=true"
import script from "./cUserFeedback.vue?vue&type=script&lang=js"
export * from "./cUserFeedback.vue?vue&type=script&lang=js"
import style0 from "./cUserFeedback.vue?vue&type=style&index=0&id=addf2df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addf2df8",
  null
  
)

export default component.exports